"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalystDeploymentEvent = void 0;
const auth_chain_1 = require("../../misc/auth-chain");
const validation_1 = require("../../validation");
const entity_1 = require("../entity");
const base_1 = require("./base");
var CatalystDeploymentEvent;
(function (CatalystDeploymentEvent) {
    CatalystDeploymentEvent.schema = {
        type: 'object',
        properties: {
            type: { type: 'string', const: base_1.Events.Type.CATALYST_DEPLOYMENT },
            subType: {
                type: 'string',
                enum: Object.values(base_1.Events.SubType.CatalystDeployment)
            },
            key: { type: 'string' },
            timestamp: { type: 'number', minimum: 1 },
            entity: entity_1.Entity.schema,
            authChain: auth_chain_1.AuthChain.schema
        },
        required: ['type', 'subType', 'entity', 'authChain', 'key', 'timestamp'],
        additionalProperties: false
    };
    CatalystDeploymentEvent.validate = (0, validation_1.generateLazyValidator)(CatalystDeploymentEvent.schema);
})(CatalystDeploymentEvent = exports.CatalystDeploymentEvent || (exports.CatalystDeploymentEvent = {}));
//# sourceMappingURL=catalyst.js.map